import { render, staticRenderFns } from "./fournisseur_view.vue?vue&type=template&id=6249f7a6&scoped=true&"
import script from "./fournisseur_view.vue?vue&type=script&lang=js&"
export * from "./fournisseur_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6249f7a6",
  null
  
)

export default component.exports